"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdLaravelAppdefs = require("cccisd-laravel-appdefs");
var _checkmarkCircle = _interopRequireDefault(require("cccisd-icons/checkmark-circle"));
var _calendar = _interopRequireDefault(require("cccisd-icons/calendar2"));
var _radioUnchecked = _interopRequireDefault(require("cccisd-icons/radio-unchecked"));
var _pen = _interopRequireDefault(require("cccisd-icons/pen5"));
var _DeploymentPlayer = _interopRequireDefault(require("../../../DeploymentPlayer"));
var _DatePicker = _interopRequireDefault(require("./DatePicker"));
var _style = _interopRequireDefault(require("./style.css"));
var _excluded = ["additionalInfo"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Boilerplate = window.cccisd.boilerplate;
function FixedSessionPlayer(_ref) {
  var assignmentData = _ref.assignmentData,
    _ref$assignmentData = _ref.assignmentData,
    deploymentList = _ref$assignmentData.deploymentList,
    assignmentProgressList = _ref$assignmentData.assignmentProgressList,
    navigationSettings = _ref$assignmentData.settings.navigationSettings,
    currentGroup = _ref.currentGroup,
    loadData = _ref.loadData;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    sessions = _useState4[0],
    setSessions = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    currentSession = _useState6[0],
    setCurrentSession = _useState6[1];
  var completionModalRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    var sessionsWithAdditionalInfo = getSessionsWithAdditionalInfo(navigationSettings.sessions, assignmentProgressList);
    setSessions(sessionsWithAdditionalInfo);
    var currentSessionIndex = getCurrentSessionIndex(sessionsWithAdditionalInfo);
    changeSession(sessionsWithAdditionalInfo[currentSessionIndex]);
  }, [assignmentData]);
  function getSessionsWithAdditionalInfo(sessionsArr, apList) {
    return sessionsArr.map(function (session) {
      var progress = apList.find(function (ap) {
        return ap.deployment.deploymentHandle === session.handle;
      }) || {};
      var additionalInfo = progress.additionalInfo,
        rest = _objectWithoutProperties(progress, _excluded);
      return _objectSpread(_objectSpread(_objectSpread({}, session), additionalInfo), rest);
    });
  }
  function getCurrentSessionIndex(sessionsArr) {
    var index = sessionsArr.findIndex(function (session) {
      return !session.completed && session.wasSessionHeld !== false;
    });
    if (index === -1) {
      return 0;
    }
    return index;
  }
  var changeSession = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return setIsLoading(true);
          case 1:
            _context.n = 2;
            return setCurrentSession(e);
          case 2:
            setIsLoading(false);
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function changeSession(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  function _handleCalendarSubmit2(_x2) {
    return _handleCalendarSubmit.apply(this, arguments);
  }
  function _handleCalendarSubmit() {
    _handleCalendarSubmit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(_ref3) {
      var wasSessionHeld, sessionDate, deploymentId;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            wasSessionHeld = _ref3.wasSessionHeld, sessionDate = _ref3.sessionDate;
            _context3.n = 1;
            return setIsLoading(true);
          case 1:
            deploymentId = !currentSession.deployment ? deploymentList.find(function (deployment) {
              return deployment.deploymentHandle === currentSession.handle;
            }).deploymentId : currentSession.deployment.deploymentId;
            _context3.n = 2;
            return _cccisdAxios["default"].post(Boilerplate.route('api.assignmentProgress.update'), {
              deploymentId: deploymentId,
              pawnId: currentGroup.pawnId,
              flowlist: 'default',
              additional_info: {
                wasSessionHeld: wasSessionHeld,
                sessionDate: sessionDate
              }
            }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
              return _regenerator().w(function (_context2) {
                while (1) switch (_context2.n) {
                  case 0:
                    setCurrentSession(_objectSpread(_objectSpread({}, currentSession), {}, {
                      wasSessionHeld: wasSessionHeld,
                      sessionDate: sessionDate
                    }));
                  case 1:
                    return _context2.a(2);
                }
              }, _callee2);
            })))["catch"](function (err) {
              return console.error(err);
            });
          case 2:
            setIsLoading(false);
          case 3:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return _handleCalendarSubmit.apply(this, arguments);
  }
  var SessionPicker = function SessionPicker() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: 'btn-group mb-3 ' + _style["default"].sessionPicker,
      role: "group"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "dropdown"
    }, /*#__PURE__*/_react["default"].createElement("button", {
      className: 'btn btn-lg btn-primary dropdown-toggle ' + _style["default"].toggle,
      type: "button",
      "data-bs-toggle": "dropdown",
      "aria-expanded": "false"
    }, currentSession.completed || currentSession.wasSessionHeld === false ? /*#__PURE__*/_react["default"].createElement(_checkmarkCircle["default"], {
      spaceRight: true
    }) : /*#__PURE__*/_react["default"].createElement(_radioUnchecked["default"], {
      spaceRight: true
    }), currentSession.label), /*#__PURE__*/_react["default"].createElement("ul", {
      className: "dropdown-menu"
    }, sessions.map(function (session) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: session.handle,
        className: "fs-5 ".concat(session.completed ? _style["default"].completed : '', " ").concat(session.handle === currentSession.handle ? _style["default"].active : '')
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: 'dropdown-item pt-3 pb-3 ' + (session.handle === currentSession.handle ? 'active' : ''),
        href: "#",
        onClick: function onClick() {
          return changeSession(session);
        }
      }, session.completed || session.wasSessionHeld === false ? /*#__PURE__*/_react["default"].createElement(_checkmarkCircle["default"], {
        spaceRight: true
      }) : /*#__PURE__*/_react["default"].createElement(_radioUnchecked["default"], {
        spaceRight: true
      }), session.label, /*#__PURE__*/_react["default"].createElement("span", {
        className: 'd-block fs-6 ' + _style["default"].surveyCount
      }, /*#__PURE__*/_react["default"].createElement(_pen["default"], {
        spaceRight: true
      }), Object.keys(session.surveys).length, " surveys")));
    }))), navigationSettings.datePicker && /*#__PURE__*/_react["default"].createElement(_DatePicker["default"], {
      wasSessionHeld: currentSession.wasSessionHeld,
      sessionDate: (0, _moment["default"])(currentSession.sessionDate),
      updateSessionHeldStatus: function updateSessionHeldStatus(status) {
        return setCurrentSession(_objectSpread(_objectSpread({}, currentSession), {}, {
          wasSessionHeld: status
        }));
      },
      updateSessionDate: function updateSessionDate(_ref4) {
        var startDate = _ref4.startDate;
        return setCurrentSession(_objectSpread(_objectSpread({}, currentSession), {}, {
          sessionDate: startDate
        }));
      },
      handleCalendarSubmit: function handleCalendarSubmit(e) {
        return _handleCalendarSubmit2(e);
      }
    }));
  };
  var CompletionModal = function CompletionModal() {
    var ModalContents = function ModalContents(_ref5) {
      var closeModal = _ref5.closeModal;
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column'
        }
      }, /*#__PURE__*/_react["default"].createElement("h1", {
        style: {
          textAlign: 'center',
          padding: '200px 0',
          margin: '0'
        }
      }, currentSession.label, " for ", currentGroup.label, " completed!", /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          color: '#1ad41b',
          fontSize: '75px'
        }
      }, /*#__PURE__*/_react["default"].createElement(_checkmarkCircle["default"], null))), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-success btn-sm",
        style: {
          width: '100%'
        },
        onClick: function onClick() {
          return closeModal();
        }
      }, "OK"));
    };
    return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
      ref: completionModalRef,
      bodyStyle: {
        overflow: 'hidden'
      },
      title: "".concat(currentSession.label, " Complete"),
      beforeClose: function beforeClose() {
        loadData();
      }
    }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelAppdefs.Confetti, {
      positionOverride: "absolute"
    }), /*#__PURE__*/_react["default"].createElement(ModalContents, null));
  };
  return currentSession && /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
    loading: isLoading,
    removeChildren: true
  }, /*#__PURE__*/_react["default"].createElement(SessionPicker, {
    sessions: sessions
  }), !isLoading && (!navigationSettings.datePicker || currentSession.wasSessionHeld) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_DeploymentPlayer["default"], {
    deploymentHandle: currentSession.handle,
    pawnId: currentGroup.pawnId,
    pawnHash: currentGroup.pawnHash,
    flowProps: _objectSpread(_objectSpread({}, currentGroup.flowProps), {}, {
      variables: _objectSpread(_objectSpread({}, currentGroup.flowProps && currentGroup.flowProps.variables), {}, {
        session: currentSession.label,
        sessionDate: (0, _moment["default"])(currentSession.sessionDate).format('MM/DD/YYYY')
      })
    }),
    onComplete: function onComplete() {
      completionModalRef.current.open();
    },
    disableLayout: true,
    enablePrintMode: true
  }), /*#__PURE__*/_react["default"].createElement(CompletionModal, null)), navigationSettings.datePicker && currentSession.wasSessionHeld === undefined && /*#__PURE__*/_react["default"].createElement(_DatePicker["default"], {
    renderFormat: "page",
    wasSessionHeld: currentSession.wasSessionHeld,
    sessionDate: (0, _moment["default"])(currentSession.sessionDate),
    updateSessionHeldStatus: function updateSessionHeldStatus(status) {
      return setCurrentSession(_objectSpread(_objectSpread({}, currentSession), {}, {
        wasSessionHeld: status
      }));
    },
    updateSessionDate: function updateSessionDate(_ref6) {
      var startDate = _ref6.startDate;
      return setCurrentSession(_objectSpread(_objectSpread({}, currentSession), {}, {
        sessionDate: startDate
      }));
    },
    handleCalendarSubmit: function handleCalendarSubmit(e) {
      return _handleCalendarSubmit2(e);
    }
  }), navigationSettings.datePicker && currentSession.wasSessionHeld === false && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginTop: '8rem'
    }
  }, /*#__PURE__*/_react["default"].createElement("h2", null, "This session was indicated as ", /*#__PURE__*/_react["default"].createElement("em", null, "missed"), ". \uD83D\uDE22"), /*#__PURE__*/_react["default"].createElement("p", null, "To change this status, click the", ' ', /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_calendar["default"], null)), ' ', "above and select the ", /*#__PURE__*/_react["default"].createElement("strong", null, "Held"), " option.")));
}
var _default = exports["default"] = FixedSessionPlayer;